import { getErrorCode } from '~/modules/processing-personal/PersonalDataApplicationForm/utils/errorUtils.ts';
import { errorMessages } from '~/constants/errorMessages.ts';
import { ERROR_CODES, HTTP_ERROR_STATUS } from '~/constants/errorCodes.ts';
import { setPersonalDataApplicationsError } from '~/store/processing-personal/slices.ts';
import { AppDispatch } from '~/store/store';
import type { TApiErrorLike } from '~/store/types.ts';

const isApiError = (error: unknown): error is TApiErrorLike =>
  typeof error === 'object' && error !== null;

export const SignatureError = (error: unknown, dispatch?: AppDispatch): void => {
  const apiError: TApiErrorLike = isApiError(error) ? error : {};
  const code = getErrorCode(error);
  let text = errorMessages.SERVICE_UNAVAILABLE;

  if (apiError.status === HTTP_ERROR_STATUS.INTERNAL_SERVER_ERROR) {
    const errorCode = ERROR_CODES.EDR_NAIS_API_ERROR.toString();

    if (apiError.data?.errorCode?.toString() === errorCode) {
      text = errorMessages.SERVICE_UNAVAILABLE;
    } else if (
      apiError.data?.errorCode &&
      Object.values(ERROR_CODES).includes(+apiError.data.errorCode)
    ) {
      text = errorMessages.SERVICE_UNAVAILABLE;
    }
  }

  if (code === ERROR_CODES.DOCUMENT_FETCH_FAILED && apiError.response?.data?.message) {
    text = apiError.response.data.message;
  }

  dispatch?.(setPersonalDataApplicationsError(text));
};
